module.exports = __webpack_public_path__ + "static/img/pay.b5dece6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/pay.png
// module id = 5os5
// module chunks = 0